export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "b77a2646e9mshae926855b33bacep10f078jsn55e7deee4f61",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const ONE_CALL_API = "https://api.openweathermap.org/data/3.0/onecall";
export const WEATHER_API_KEY = "203fe7b079b4b3f7c022eab720f2638a";
